<div class="billing-cycle-selector">
  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Billing Cycle</mat-label>
      <mat-select [formControl]="billingCycleControl">
        <mat-option *ngFor="let cycle of billingCycles" [value]="cycle.id">
          {{ getCycleLabel(cycle.type) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="cycleNeedsBillingDay()" appearance="outline" class="form-field">
      <mat-label>Billing Day</mat-label>
      <input
        matInput
        [formControl]="billingDayControl"
        type="number"
        placeholder="Enter billing day (1-31)"
        min="1"
        max="31"
      />
    </mat-form-field>
  </div>

  <!-- Billing Cycle Properties -->
  <div *ngIf="getSelectedBillingCycle()" class="billing-cycle-details">
    <h3>Selected Billing Cycle Details</h3>
    <div class="cycle-properties">
      <div class="property-item">
        <span class="property-label">Type:</span>
        <span class="property-value">{{ getSelectedBillingCycle()?.type }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Pro Rate:</span>
        <span class="property-value">{{ getSelectedBillingCycle()?.proRate ? 'Yes' : 'No' }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Delayed Start:</span>
        <span class="property-value">{{
          getSelectedBillingCycle()?.delayedStart ? 'Yes' : 'No'
        }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Split Cycle:</span>
        <span class="property-value">{{
          getSelectedBillingCycle()?.splitCycle ? 'Yes' : 'No'
        }}</span>
      </div>
      <div class="property-item">
        <span class="property-label">Annual:</span>
        <span class="property-value">{{ getSelectedBillingCycle()?.annual ? 'Yes' : 'No' }}</span>
      </div>
    </div>
  </div>
</div>
